import { configureStore } from '@reduxjs/toolkit';
import memori2 from './reduser';

export const store = configureStore({
  reducer: {
    generalState: memori2,
  },
});
